import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, AlertCircle, Calendar, Activity, CheckCircle, UserX } from 'lucide-react';

interface MetricsCardsProps {
  totalStakeholders: number;
  overdueFollowUps: number;
  todayFollowUps: number;
  weekInteractions: number;
  followUpCompletionRate: number;
  inactiveStakeholders: number;
}

export function MetricsCards({ 
  totalStakeholders, 
  overdueFollowUps, 
  todayFollowUps, 
  weekInteractions,
  followUpCompletionRate,
  inactiveStakeholders
}: MetricsCardsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium">Tổng Stakeholders</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-xl sm:text-2xl font-bold">{totalStakeholders}</div>
          <p className="text-xs text-muted-foreground">
            Stakeholders trong hệ thống
          </p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium">Quá hạn Follow-up</CardTitle>
          <AlertCircle className="h-4 w-4 text-destructive" />
        </CardHeader>
        <CardContent>
          <div className="text-xl sm:text-2xl font-bold text-destructive">{overdueFollowUps}</div>
          <p className="text-xs text-muted-foreground">
            Cần xử lý ngay
          </p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium">Follow-up Hôm nay</CardTitle>
          <Calendar className="h-4 w-4 text-primary" />
        </CardHeader>
        <CardContent>
          <div className="text-xl sm:text-2xl font-bold text-primary">{todayFollowUps}</div>
          <p className="text-xs text-muted-foreground">
            Lịch hẹn trong ngày
          </p>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium">Tương tác tuần này</CardTitle>
          <Activity className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-xl sm:text-2xl font-bold">{weekInteractions}</div>
          <p className="text-xs text-muted-foreground">
            7 ngày qua
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium">Tỷ lệ hoàn thành</CardTitle>
          <CheckCircle className="h-4 w-4 text-green-600" />
        </CardHeader>
        <CardContent>
          <div className="text-xl sm:text-2xl font-bold text-green-600">{followUpCompletionRate}%</div>
          <p className="text-xs text-muted-foreground">
            Follow-ups đã hoàn thành
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium">Cần quan tâm</CardTitle>
          <UserX className="h-4 w-4 text-amber-600" />
        </CardHeader>
        <CardContent>
          <div className="text-xl sm:text-2xl font-bold text-amber-600">{inactiveStakeholders}</div>
          <p className="text-xs text-muted-foreground">
            Không tương tác 30 ngày
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
